import {ResolveFn} from '@angular/router';
import {isPlatformBrowser} from '@angular/common';
import {inject, PLATFORM_ID} from '@angular/core';

export const externalRedirectResolver: ResolveFn<void> = (): void => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) return;
  window.location.href = 'https://processway.pl';
};
